<template>
  <input
    ref="imageInput"
    accept="image/*"
    type="file"
    multiple
    hidden
    v-on:change="onChangeImage"
  />
</template>

<script>
import { handleFile } from '@common/lib/common/imgUtils';

export default {
  name: 'component-image-input',
  description: '이미지 인풋 컴포넌트',
  data() {
    return {
      imageFile: {},
      images: [],
    };
  },
  methods: {
    click() {
      this.$refs.imageInput.click();
    },
    async onChangeImage(e) {
      // 저장하기 위해 신규 이미지파일들 바이너리 배열로 변경
      const maxWidth = 1024,
        quality = 0.92,
        enableCompress = true;
      this.file = null;
      this.images = [];
      var handle;
      const imageInfo = {};
      for (var i = 0; i < e.target.files.length; i++) {
        if (e.target.files[i]) {
          const file = e.target.files[i];
          const doSquash = file.type === 'image/jpeg';
          handle = handleFile(
            file,
            {
              maxWidth,
              quality,
              enableCompress,
            },
            doSquash,
          ).then(blob => {
            const blobURL = URL.createObjectURL(blob);
            const fileItem = {
              url: blobURL,
              blob,
            };
            for (let key in file) {
              if (['slice', 'webkitRelativePath'].indexOf(key) === -1) {
                fileItem[key] = file[key];
              }
            }
            this.file = fileItem;

            imageInfo.imagePath = fileItem.url;
            imageInfo.imageSize = fileItem.size;
            imageInfo.imageType = fileItem.type;
            imageInfo.file = fileItem.blob;

            this.images.push({ ...imageInfo });

            // this.images = {
            //   imagePath: fileItem.url,
            //   imageSize: fileItem.size,
            //   imageType: fileItem.type,
            //   file: fileItem.blob,
            // };
            // this.images.push(i);
          });
        } else {
          this.file = null;
        }
      }

      console.log('imageimageimageimagewere');
      console.log(this.images);

      this.$emit('change', this.images);
    },
  },
};
</script>

<style></style>
